module.exports = __webpack_public_path__ + "assets/gongwenbao.52e741e2.svg";